import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import styles from './BrandProducts.module.css';
import * as actions from '../../store/actions/index';
import Spinner from '../Spinner/Spinner';
import FlexContainer from '../UI/FlexContainer/FlexContainer';
import ProductCard from '../ProductCard/ProductCard';
import {string_to_slug as slug} from "../../store/utility"
 

const BrandProducts = (props)=>{

    let {brandId, brandName,productType} = props.match.params;

    useEffect(()=>{

        props.getCategoryTypeList();
        props.onFetchBrandProducts(brandId,productType)
        // props.onFetchWishlist(props.userId)
    },[])

 
    useEffect(()=>{

        props.onFetchBrandProducts(brandId,productType)

    },[props.location.pathname])

    // useEffect(()=>{

    //     props.onFetchWishlist(props.userId)

    // },[props.userId])



   const  getNavUrl = (item)=>{
        let {brandId, brandName} = props.match.params;
        let url  = null;
       
            url = "/brand/"+slug(brandName)+"/"+brandId+"/"+item.id.replaceAll(" ", "").toLowerCase()
       
       return url;
     }

     let spinner = (<div className={styles.Spinner}><Spinner /></div>); 
    return(
        <>
        <nav className={"navbar navbar-light bg-light text-center d-flex justify-content-around " + styles.Navbar}>
            {/* renders the nav */}
            {props.categoryTypeList&&props.categoryTypeList.map((item) =>
               
                <NavLink
                 onClick={() => props.updateCategoryType(item.id.replaceAll(" ", "").toLowerCase())}
                 to={getNavUrl(item)}
                 key={item.id}
                 className={styles.Link}
                 activeClassName={styles.Active}>
                {item.name}</NavLink>
             
            )}
        </nav>

        {props.brandProducts.length > 0 ?
            <div className="container container-md" style={{ padding: "20px" }}>
               <FlexContainer>

               {props.brandProducts.map((product) => (
                   <>
                    <ProductCard product={product} />
                   
                   </>
                   
               ))
                }
            

               </FlexContainer>
               {!props.leadsexhausted ? (
                <div style={{ width: "100%", textAlign: "center" }}>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() =>
                    props.onLoadMoreBrandProducts(
                        props.leadsexhausted,
                        props.limit,
                        props.lastDoc,
                        brandId,
                        productType
                    )
                    }
                    disabled={props.loadmore}
                  >
                    {props.loadmore?"Loading":"Load More"}
                  </button>
                </div>
              ) : null}
                   
                
            </div> : null}
        {props.loading ? spinner : null}

    </>

    )
}

const mapStateToProps = state=>{
    return{ 
        categoryType: state.categoryProducts.categoryType,
        categoryTypeList:state.categoryProducts.categoryTypeList,
        brandProducts:state.brands.brandProducts,
        leadsexhausted: state.brands.leadsexhausted,
        limit: state.brands.limit,
        lastDoc: state.brands.lastDoc,
        loadmore: state.brands.loadMore,
        loading:state.brands.loading,
        userId:state.auth.userId
    }
}

const mapDispatchToProps = dispatch=>{
    return {
        getCategoryTypeList:()=>dispatch(actions.getCategoryTypeList()),
        updateCategoryType: (categoryType) => dispatch(actions.updateCategoryType(categoryType)),
        onFetchBrandProducts:(brandId,productTypeId)=>dispatch(actions.onFetchBrandProducts(brandId,productTypeId)),
        onLoadMoreBrandProducts:(leadsexhausted, limit, lastDoc, brandId, productTypeId)=>dispatch(actions.onLoadMoreBrandProducts(leadsexhausted, limit, lastDoc, brandId, productTypeId)),
        onFetchWishlist: (userId) => dispatch(actions.onFecthWishlist(userId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BrandProducts)); 